import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import './App.css';
import Welcome from './screens/Welcome';
import Poems from './screens/Poems';
import Paintings from './screens/Paintings';
import Photographs from './screens/Photographs';
import Buyerszone from './screens/Buyerszone';
import More from './screens/More';
import Privacypolicy from './screens/Privacypolicy';
import Paintingdetails from './components/Paintings/Paintingdetails';
import Photographdetails from './components/Photographs/Photographdetails';
import Poemdetails from './components/Poems/Poemdetails';
import Billingpagecard from './components/Buyerszone/Payments/Billingpagecard';
import Billingdetailspagecard from './components/Buyerszone/Payments/Billingdetailspagecard';
import PaintingImagePage from './components/Buyerszone/Paintings/PaintingImagePage';
import { PaymentSuccess } from './components/Buyerszone/Payments/PaymentSuccess';
import ScrollToTop from './utility/ScrollToTop';

import ContactUs from './Footer/ContactUs';
import PricingPage from './Footer/PricingPage';
import ShippingPolicy from './Footer/ShippingPolicy';
import RefundPolicy from './Footer/Refundpolicy';
import Terms from './Footer/Terms';
import AboutusPage from './Footer/AboutusPage';
import PrivacyPolicy from './Footer/PrivacyPolicy';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <header className="app-header">
          <DisplayText />
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/poems" element={<Poems />} />
            <Route path="/paintings" element={<Paintings />} />
            <Route path="/photographs" element={<Photographs />} />
            <Route path="/buyerszone" element={<Buyerszone />} />
            <Route path="/more" element={<More />} />
            <Route path="/painting/:id" element={<Paintingdetails />} />
            <Route path="/paintings/:id" element={<PaintingImagePage />} />
            <Route path="/photograph/:id" element={<Photographdetails />} />
            <Route path="/poem/:id" element={<Poemdetails />} />
            <Route path="/billing" element={<Billingpagecard />} />
            <Route path="/billingdetails" element={<Billingdetailspagecard />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            {/* footer routes */}
            <Route path="/aboutus" element={<AboutusPage />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/shippingpolicy" element={<ShippingPolicy />} />
            <Route path="/refundpolicy" element={<RefundPolicy />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/termsandconditions" element={<Terms />} />
          </Routes>
        </header>

        <footer className="app__footer">
          <div className="app__footer-content">
            <div className="app__footer-section">
              <ul className="app__footer-menu">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/poems">Poems</Link></li>
                <li><Link to="/paintings">Paintings</Link></li>
                <li><Link to="/photographs">Photographs</Link></li>
                <li><Link to="/buyerszone">Buyer's Zone</Link></li>
                <li><Link to="/more?tab=Articles">Articles</Link></li>
                <li><Link to="/more?tab=Connect">Connect</Link></li>
                <li><Link to="/more?tab=ForMe">For Me</Link></li>
              </ul>
            </div>
          </div>
          <div className="app_footer-bottom">
            <p>&nbsp;
              <Link to="/aboutus" className="privacypolicy">About Us</Link>
              <Link to="/contactus" className="privacypolicy">Contact Us</Link>
              <Link to="/pricing" className="privacypolicy">Pricing</Link>
              <Link to="/shippingpolicy" className="privacypolicy">Shipping Policy</Link>
              <Link to="/refundpolicy" className="privacypolicy">Refund Policy</Link>
              <Link to="/privacypolicy" className="privacypolicy">Privacy Policy</Link>
              <Link to="/termsandconditions" className="privacypolicy">Terms and Conditions</Link>
            </p>
            {/* <p>
              &copy;&nbsp;{new Date().getFullYear()} SENTHIL NATHAN Art Gallery. &nbsp;All Rights Reserved.
            </p> */}
            <p>
              &copy;&nbsp;
              {new Date().getFullYear() - 1} - {new Date().getFullYear()}{" "}
              {/* SENTHIL NATHAN Art Gallery. &nbsp;All Rights Reserved. */}
              SENTHIL NATHAN Art Gallery.
              <span className="rights-text">All Rights Reserved.</span>
            </p>
          </div>
          <div className="app_footer-bottom1">
            <p>&nbsp;
              <Link to="/aboutus" className="privacypolicy">About Us</Link>
              <Link to="/contactus" className="privacypolicy">Contact Us</Link>
              <Link to="/pricing" className="privacypolicy">Pricing</Link>
            </p>
            <p>
              <Link to="/shippingpolicy" className="privacypolicy">Shipping Policy</Link>
              <Link to="/refundpolicy" className="privacypolicy">Refund Policy</Link>
              <Link to="/privacypolicy" className="privacypolicy">Privacy Policy</Link>
            </p>
            <p>
              <Link to="/termsandconditions" className="privacypolicy">Terms and Conditions</Link>
            </p>
            {/* <p className="app_footer-bottom-copyrights">
              &copy;&nbsp;{new Date().getFullYear()} SENTHIL NATHAN Art Gallery. &nbsp;<br />All Rights Reserved.
            </p> */}
            <p className="app_footer-bottom-copyrights">
              &copy;&nbsp;
              {new Date().getFullYear() - 1} - {new Date().getFullYear()}{" "}
              {/* SENTHIL NATHAN Art Gallery. &nbsp;All Rights Reserved. */}
              SENTHIL NATHAN Art Gallery.
              <span className="rights-text">All Rights Reserved.</span>
            </p>
          </div>
        </footer>
      </div>
    </Router>
  );
}


function DisplayText() {
  const location = useLocation();

  return (
    location.pathname === '/' && (
      <nav className="display-text__nav">
        <span className="display-text__dot"></span>
        <h1 className="display-text__title">SENTHIL NATHAN</h1>
        <ul className="display-text__menu">
          <li className="display-text__menu-item">
            <Link to="/poems">Poems</Link>
          </li>
          <li className="display-text__menu-item">
            <Link to="/buyerszone">Buyer's Zone</Link>
          </li>
          <li className="display-text__menu-item">
            <Link to="/paintings">Paintings</Link>
          </li>
          <li className="display-text__menu-item display-text__menu-item--more">
            <Link to="/more?tab=Articles">More</Link>
            {/* <ul className="submenu">
              <li className="submenu-item">Articles</li>
              <li className="submenu-item">About</li>
              <li className="submenu-item">For Me</li>
            </ul> */}
          </li>
          <li className="display-text__menu-item">
            <Link to="/photographs">Photographs</Link>
          </li>
        </ul>

        <ul className="display-text__mobile-menu">
          <li className="display-text__menu-item">
            <Link to="/poems">Poems</Link>
          </li>

          <li className="display-text__menu-item">
            <Link to="/paintings">Paintings</Link>
          </li>

          <li className="display-text__menu-item">
            <Link to="/photographs">Photographs</Link>
          </li>
          <li className="display-text__menu-item">
            <Link to="/buyerszone">Buyer's Zone</Link>
          </li>
          <li className="display-text__menu-item display-text__menu-item--more">
            <Link to="/more?tab=Articles">More</Link>
            {/* <ul className="submenu">
              <li className="submenu-item">Articles</li>
              <li className="submenu-item">About</li>
              <li className="submenu-item">For Me</li>
            </ul> */}
          </li>
        </ul>
      </nav>
    )
  );
}


export default App;